import { createSlice } from "@reduxjs/toolkit";

let initalState = {
    sidebar: false,
    ad_popup: false,
    isSearchWindowOpen: false, // New state for search window visibility
    searchQuery: "", // New state for the search input value
    searchResults: {
        products: [],
        collections: [],
    }, // New state for search results
    isLogin: false,
    user: null,
    showLoading: false
};

export const slice = createSlice({
    name: "appstate",
    initialState: initalState,
    reducers: {
        setSidebar: (state, action) => {
            state.sidebar = action.payload;
        },
        showAdPopup: (state) => {
            state.ad_popup = true;
        },
        hideAdPopup: (state) => {
            state.ad_popup = false;
        },
        startLoading: (state) => {
          state.showLoading = true;
        },
        stopLoading: (state) => {
          state.showLoading = false;
        },
        // New reducers for search functionality
        setSearchWindow: (state, action) => {
            state.isSearchWindowOpen = action.payload;
        },
        setSearchQuery: (state, action) => {
            state.searchQuery = action.payload;
        },
        setSearchResults: (state, action) => {
            state.searchResults = action.payload;
        },
        setIsLogin: (state, action) => {
            state.isLogin = action.payload;
        },
        setUser: (state, action) => {
            state.user = action.payload;
        },
    },
});

export const {
    setSidebar,
    showAdPopup,
    hideAdPopup,
    setSearchWindow,
    setSearchQuery,
    setSearchResults,
    setIsLogin,
    setUser,
    startLoading, stopLoading
} = slice.actions;
export default slice.reducer;
